import React, { cloneElement, isValidElement } from 'react';

type HighlightProps = {
    children: React.ReactNode;
    searchText?: string;
};

export const Highlight: React.FC<HighlightProps> = ({ children, searchText }) => {
    // no 'searchText' - do nothing
    if (!searchText) {
        return <>{children}</>;
    }

    const strSearchText = String(searchText);
    const regex = new RegExp(`(${strSearchText})`, 'gi');

    function highlightReactComponent() {
        return React.Children.map(children, (child) => {
            if (isValidElement(child) && typeof child.props.children === 'string') {
                const parts = child.props.children.split(regex);
                return cloneElement(child, child.props, parts.map((part: any, index: any) =>
                    part.toLowerCase() === strSearchText.toLowerCase() ? (
                        <span key={`${index}-${part}`} className="highlight">{part}</span>
                    ) : (part)
                ));
            }
            return child;
        });
    }

    // children is a React component
    if (isValidElement(children)) {
        return <>{highlightReactComponent()}</>;
    }

    // children is a String
    if (typeof children !== 'string' && typeof children !== 'number') {
        return <>{children}</>;
    }

    const parts = String(children).split(regex);
    return (
        <>
            {parts.map((part, index) =>
                part.toLowerCase() === strSearchText.toLowerCase() ? (
                    <span key={`${index}-${part}`} className="highlight">{part}</span>) : (part))}
        </>
    );
};